<template>
  <v-menu bottom min-width="200px" offset-y offset-x>
    <template v-slot:activator="{ on }">
      <v-btn icon x-large v-on="on">
        <v-badge
          value="true"
          :content="getBadgeText()"
          :bordered="
            $store.getters.isAdmin ||
            $store.getters.isReviewer ||
            $store.getters.isProUser
          "
          bottom
          :color="getBadgeColor()"
          offset-x="50"
          offset-y="10"
        >
          <v-avatar color="blue" size="48">
            <span class="white--text text-h5">
              {{ $store.getters.getInitial }}
            </span>
          </v-avatar>
        </v-badge>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center">
        <div class="mx-auto text-center">
          <v-avatar color="blue">
            <span class="white--text text-h5">
              {{ $store.getters.getInitial }}
            </span>
          </v-avatar>
          <h4 class="mt-2">{{ $store.state.user }}</h4>
          <span class="text--secondary" v-if="!$store.getters.isUser">
            {{ $store.getters.getAllRoles }}
          </span>
          <v-divider class="my-3"></v-divider>
          <v-btn depressed text to="/settings"> Settings </v-btn>
          <v-divider class="my-3"></v-divider>
          <v-btn depressed text @click="signOut()"> Sign out </v-btn>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    signOut() {
      this.$store.dispatch("logout");
      this.$router.push({ path: "/login" });
      location.reload();
    },
    getBadgeText() {
      console.log("getBadgeText called");
      if (this.$store.getters.getHighestRole.toUpperCase() == "USER") {
        if (this.$store.getters.isProUser) {
          console.log("is pro user");
          return "PRO";
        }
        return "";
      }
      return this.$store.getters.getHighestRole.toUpperCase();
    },
    getBadgeColor() {
      if (this.$store.getters.isAdmin) {
        return "red";
      }
      if (this.$store.getters.isReviewer) {
        return "green";
      }
      if (this.$store.getters.isProUser) {
        return "orange";
      }
      return "transparent";
    },
  },
};
</script>

<style></style>
